package ai.wagemix.net.client

import ai.wagemix.net.models.WMBillingPortalSessionCreate
import com.fsryan.foundation.net.client.FSAuthenticatedRequestBuilder
import com.fsryan.foundation.net.client.FSRequest
import com.fsryan.foundation.net.client.acceptJson
import com.fsryan.foundation.net.client.contentTypeJson
import com.fsryan.foundation.net.client.replacePathParams

/** `POST /api/v1/billing/portal-sessions`: a Stripe billing-portal session for the signed-in user. */
class WMCreateBillingPortalSessionRequestBuilder:
    FSAuthenticatedRequestBuilder<WMCreateBillingPortalSessionRequestBuilder, WMBillingPortalSessionCreate>() {

    override fun build(): FSRequest<WMBillingPortalSessionCreate> {
        method(FSRequest.Method.Post)
        replacePathParams("api", "v1", "billing", "portal-sessions")
        acceptJson()
        contentTypeJson()
        return super.build()
    }

    override fun self(): WMCreateBillingPortalSessionRequestBuilder = this
}
